import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "helpBooksContext" }

import { computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import WebUseZh from "./WebUseZh.vue";
import WebUseEn from "./WebUseEn.vue";
import InstallForUseZh from "./InstallForUseZh.vue";
import InstallForUseEn from "./InstallForUseEn.vue";
import DecUseZh from "./DecUseZh.vue";
import DecUseEn from "./DecUseEn.vue";
import ScrollToTmp from "./ScrollToTmp.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const appLanguage = computed(() => useStore().state.appLanguage);
const activeName = computed(() => useRoute().params.type as string);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(appLanguage) === 'zh')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_unref(activeName) === 'web-use')
              ? (_openBlock(), _createBlock(WebUseZh, { key: 0 }))
              : _createCommentVNode("", true),
            (_unref(activeName) === 'dec-install')
              ? (_openBlock(), _createBlock(InstallForUseZh, { key: 1 }))
              : _createCommentVNode("", true),
            (_unref(activeName) === 'dec-use')
              ? (_openBlock(), _createBlock(DecUseZh, { key: 2 }))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_unref(activeName) === 'web-use')
              ? (_openBlock(), _createBlock(WebUseEn, { key: 0 }))
              : _createCommentVNode("", true),
            (_unref(activeName) === 'dec-install')
              ? (_openBlock(), _createBlock(InstallForUseEn, { key: 1 }))
              : _createCommentVNode("", true),
            (_unref(activeName) === 'dec-use')
              ? (_openBlock(), _createBlock(DecUseEn, { key: 2 }))
              : _createCommentVNode("", true)
          ], 64))
    ]),
    _createVNode(ScrollToTmp, {
      lang: _unref(appLanguage),
      type: _unref(activeName)
    }, null, 8, ["lang", "type"])
  ], 64))
}
}

})